import React from "react";

import { ComponentType } from "../../constants";

import { ComponentTemplateButton } from "./ComponentTemplateButton";
import {
  ComponentTemplateDialog,
  ComponentTemplate,
} from "./ComponentTemplateDialog";

export interface UseComponentTemplateProps {
  onApplyTemplate?: (template: ComponentTemplate) => void;
  componentType?: ComponentType;
  isApplyPending?: boolean;
}

export function UseComponentTemplate(props: UseComponentTemplateProps) {
  const { onApplyTemplate, componentType } = props;
  const [open, setOpen] = React.useState(false);

  const handleOpen = React.useCallback(() => {
    setOpen(true);
  }, []);

  const handleClose = React.useCallback(() => {
    setOpen(false);
  }, []);

  const handleSelect = React.useCallback(
    (event, template) => {
      if (onApplyTemplate) {
        onApplyTemplate(template);
      }
    },
    [onApplyTemplate],
  );

  return (
    <>
      <ComponentTemplateButton onClick={handleOpen} />
      {open && (
        <ComponentTemplateDialog
          open={open}
          onClose={handleClose}
          onSelectTemplate={handleSelect}
          componentType={componentType}
        />
      )}
    </>
  );
}
